enum Organizations {
  TON ='ton',
  PAGARME = 'pagarme'
}

const isPagarme = (organization?: string) => (organization?.toLowerCase() === Organizations.PAGARME) || !organization;
const isTon = (organization?: string) => organization?.toLocaleLowerCase() === Organizations.TON;

type OrganizationNameParams = {
  organization?: string;
  accountName?: string;
  displayName?: string;
};

const getCompanyNameByOrganization = ({
  organization,
  accountName,
  displayName,
}: OrganizationNameParams): string | undefined =>
  (isTon(organization) ? accountName ?? displayName : displayName ?? accountName);

export {
  Organizations,
  isPagarme,
  isTon,
  getCompanyNameByOrganization
};
export type { OrganizationNameParams };

